// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionA8_comp__AeoAz"};